module.exports = __webpack_public_path__ + "f1a2652e6ba6d46fad1314709bfab43c.png";